import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export type DeleteHazardDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteHazardDialog({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteHazardDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-md' showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>{t('hazardsPage.deleteDialog.title')}</DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {t('hazardsPage.deleteDialog.message')}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            {t('common:actions.cancel')}
          </Button>
          <Button variant='destructive' onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? t('hazardsPage.deleteDialog.deleting') : t('hazardsPage.deleteDialog.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
